import { render } from "./AthleteDetail.vue?vue&type=template&id=cba23d08&scoped=true"
import script from "./AthleteDetail.vue?vue&type=script&lang=js"
export * from "./AthleteDetail.vue?vue&type=script&lang=js"

import "./AthleteDetail.vue?vue&type=style&index=0&id=cba23d08&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cba23d08"

export default script